import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"height":"100vh"}
}
const _hoisted_2 = {
  key: 1,
  class: "wrap-descr-product"
}
const _hoisted_3 = {
  key: 0,
  class: "product-description__form-save-status product-description__form-save-status_error"
}
const _hoisted_4 = {
  key: 1,
  class: "product-description__form-save-status product-description__form-save-status_success"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Обновить ")
const _hoisted_6 = {
  key: 0,
  class: "product-description__form-save-status product-description__form-save-status_error"
}
const _hoisted_7 = {
  key: 1,
  class: "product-description__form-save-status product-description__form-save-status_success"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Сохранить")
const _hoisted_9 = {
  key: 0,
  class: "lot-dashboard"
}
const _hoisted_10 = { class: "lot-dashboard__el" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "lot-dashboard__title" }, "Дата создания", -1)
const _hoisted_12 = { class: "lot-dashboard__value" }
const _hoisted_13 = { class: "lot-dashboard__el" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "lot-dashboard__title" }, "Дата изменения", -1)
const _hoisted_15 = { class: "lot-dashboard__value" }
const _hoisted_16 = { class: "lot-dashboard__el" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "lot-dashboard__title" }, "Статус", -1)
const _hoisted_18 = { class: "lot-dashboard__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.isLoading)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, null, 512)), [
        [_directive_loading, true]
      ])
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          class: "product-description",
          size: "small",
          style: {"width":"100%"},
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Партия" }, {
              default: _withCtx(() => [
                (_ctx.getLotsOnlyStateCounted?.length)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: _ctx.form.lot,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.lot) = $event)),
                      class: "m-2",
                      placeholder: "Обязательное поле",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLotsOnlyStateCounted, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Назначение" }, {
              default: _withCtx(() => [
                (_ctx.genders)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: _ctx.form.gender,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.gender) = $event)),
                      class: "m-2",
                      placeholder: "Обязательное поле",
                      size: "large",
                      disabled: !!_ctx.form.categoriesFirst,
                      onChange: _cache[2] || (_cache[2] = 
						() => {
							_ctx.form.categoriesFirst = ''
							_ctx.form.categoriesLast = ''
							_ctx.form.categoryType = ''
						}
					)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genders, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.key,
                            label: item.label,
                            value: item.key
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Категория" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.categoriesFirst,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.categoriesFirst) = $event)),
                  class: "m-2",
                  placeholder: "Обязательное поле",
                  disabled: !(_ctx.form.gender || _ctx.form.gender === 0) || !!_ctx.form.categoriesLast,
                  size: "large",
                  onChange: _cache[4] || (_cache[4] = 
						() => {
							_ctx.form.categoriesLast = ''
							_ctx.form.categoryType = ''
						}
					)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriesFirstLevel, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            (_ctx.categoriesLastLevel?.length)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "Подкатегория"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.categoriesLast,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.categoriesLast) = $event)),
                      class: "m-2",
                      placeholder: "Обязательное поле",
                      disabled: !!_ctx.form.categoryType,
                      size: "large",
                      onChange: _cache[6] || (_cache[6] = 
						() => {
							_ctx.form.categoryType = ''
						}
					)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriesLastLevel, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.categoriesTypesByCategoryId?.length)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "Тип товара"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.categoryType,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.categoryType) = $event)),
                      class: "m-2",
                      placeholder: "Обязательное поле",
                      disabled: !_ctx.form.categoriesLast,
                      size: "large",
                      onChange: _cache[8] || (_cache[8] = 
						() => {
							if (_ctx.form.categoryType === -1) {
								_ctx.form.categoryType = ''
							} else {
							}
						}
					)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoriesTypesByCategoryId, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "Сезон" }, {
              default: _withCtx(() => [
                (_ctx.seasons?.rows?.length)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: _ctx.form.seasons,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.seasons) = $event)),
                      multiple: "",
                      class: "m-2",
                      placeholder: "Обязательное поле",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasons.rows, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Страна" }, {
              default: _withCtx(() => [
                (_ctx.countries?.length)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      modelValue: _ctx.form.country,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.country) = $event)),
                      class: "m-2",
                      placeholder: "Обязательное поле",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.form.gender || _ctx.form.gender === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_ctx.form.gender === 4)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_form_item, { label: "Наименование" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              "model-value": _ctx.form.name,
                              "onUpdate:model-value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.name) = $event)),
                              placeholder: "Обязательное поле"
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Вес мешка (г)" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              "model-value": _ctx.form.totalWeight,
                              "onUpdate:model-value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.totalWeight) = $event)),
                              maxlength: "9",
                              onInput: _cache[13] || (_cache[13] = val => _ctx.validateDecimal('totalWeight')(val)),
                              placeholder: "Обязательное поле"
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Вещей в мешке (шт)" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              "model-value": _ctx.form.totalPieces,
                              "onUpdate:model-value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.totalPieces) = $event)),
                              maxlength: "9",
                              onInput: _cache[15] || (_cache[15] = val => _ctx.validateDecimal('totalPieces')(val)),
                              placeholder: "Обязательное поле"
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Единица ценообразования" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.form.isByWeight,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.isByWeight) = $event)),
                              class: "m-2",
                              placeholder: "Обязательное поле",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.isByWeightSelectOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.label,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Цена за единицу (€)" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              "model-value": _ctx.form.itemEuroPrice,
                              "onUpdate:model-value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.itemEuroPrice) = $event)),
                              maxlength: "9",
                              onInput: _cache[18] || (_cache[18] = val => _ctx.validateDecimal('itemEuroPrice')(val)),
                              placeholder: "Обязательное поле"
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_form_item, { label: "Бренд" }, {
                          default: _withCtx(() => [
                            (_ctx.brands?.rows?.length)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: _ctx.form.brand,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.brand) = $event)),
                                  class: "m-2",
                                  placeholder: "Обязательное поле",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands.rows, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Наименование" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              "model-value": _ctx.form.name,
                              "onUpdate:model-value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.name) = $event)),
                              placeholder: "Необязательное поле"
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Цвет" }, {
                          default: _withCtx(() => [
                            (_ctx.colors?.rows?.length)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: _ctx.form.color,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.color) = $event)),
                                  multiple: "",
                                  "multiple-limit": 5,
                                  filterable: "",
                                  class: "m-2",
                                  placeholder: "Обязательное поле",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors.rows, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Материалы" }, {
                          default: _withCtx(() => [
                            (_ctx.materials?.rows?.length)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: _ctx.form.material,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.material) = $event)),
                                  multiple: "",
                                  "multiple-limit": 5,
                                  filterable: "",
                                  class: "m-2",
                                  placeholder: "Обязательное поле",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials.rows, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Розничная цена (₽)" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              "model-value": _ctx.form.retailPrice,
                              "onUpdate:model-value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.retailPrice) = $event)),
                              maxlength: "9",
                              placeholder: "Необязательное поле",
                              onInput: _cache[24] || (_cache[24] = val => _ctx.validateDecimal('retailPrice')(val))
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        })
                      ], 64))
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "Цена в каталоге (₽)" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "model-value": _ctx.form.price,
                  "onUpdate:model-value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.price) = $event)),
                  maxlength: "9",
                  placeholder: "Обязательное поле",
                  onInput: _cache[26] || (_cache[26] = val => _ctx.validateDecimal('price')(val))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Описание" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "model-value": _ctx.form.description,
                  "onUpdate:model-value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.description) = $event)),
                  placeholder: "Необязательное поле"
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Внутренний параметр 1" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "model-value": _ctx.form.internalParam1,
                  "onUpdate:model-value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.internalParam1) = $event)),
                  placeholder: "Необязательное поле"
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Внутренний параметр 2" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "model-value": _ctx.form.internalParam2,
                  "onUpdate:model-value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.internalParam2) = $event)),
                  placeholder: "Необязательное поле"
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            (_ctx.product)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (!_ctx.isSaveProduct)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Заполните все обязательные поля для продолжения "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, " Все поля заполнены ")),
                  _createVNode(_component_el_button, {
                    loading: _ctx.isFetching,
                    disabled: !_ctx.isSaveProduct,
                    onClick: _ctx.update
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (!_ctx.isSaveProduct)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Заполните все обязательные поля для продолжения "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, " Все поля заполнены ")),
                  _createVNode(_component_el_button, {
                    loading: _ctx.isFetching,
                    disabled: !_ctx.isSaveProduct,
                    onClick: _ctx.save
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ], 64))
          ]),
          _: 1
        }),
        (_ctx.product?.created)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getStrPreatyTime(_ctx.product.created)), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getStrPreatyTime(_ctx.product.modified)), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.localizeProductStates[_ctx.enumProductState[_ctx.product.state]]), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}